import { Dispatch, SetStateAction } from 'react';
import { Button } from 'components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
} from 'components/ui/dialog';
import { Icon } from 'components/ui/icon';

interface IProps {
  status: boolean;
  showModal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
}

const STATUS_CONFIG = {
  verified: {
    icon: 'check-circle' as const,
    iconColor: 'text-green-500',
    title: 'Sale Verified',
    description: 'See transactions details for more information',
  },
  notVerified: {
    icon: 'alert-circle' as const,
    iconColor: 'text-yellow-500',
    title: 'Sale Not Verified',
    description: 'See transactions details for more information.',
  },
};

const PaymentStatus = ({
  status,
  setShowModal,
  showModal,
}: IProps): JSX.Element => {
  const config = status ? STATUS_CONFIG.verified : STATUS_CONFIG.notVerified;

  return (
    <Dialog open={showModal} onOpenChange={setShowModal}>
      <DialogContent className="max-w-sm md:mx-0 mx-4">
        <div className="flex items-start gap-3">
          <Icon
            name={config.icon}
            size={32}
            className={config.iconColor}
            aria-hidden="true"
          />
          <div>
            <h1 className="mb-2 font-semibold text-gray-blue-90">
              {config.title}
            </h1>
            <span className="text-sm text-gray-blue-70">
              {config.description}
            </span>
          </div>
        </div>
        <DialogFooter className="flex justify-end">
          <Button
            data-testid="closeDeviceStatus"
            onClick={() => setShowModal(false)}
          >
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentStatus;
